export default class IntegrationCredentials {
  nonce;

  constructor() {
    this.nonce = Math.random().toString(36).substring(7);
  }
}
